export enum NoteStateEnums {
  open = 1,
  closed = 2,
  printed = 3,
  authorized = 4,
  revised = 5,
  approved = 6,
  generated = 7,
  annulled = 8
}